import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";

// Verndale Customization
// we need to remove isc_* and product_* properties from the cartLine.properties object , since those are read only
// and not added to the app dictionary as part of the cartline object
export const removeKeysWithPrefixes = (obj: { [key: string]: any }, prefixes: string[]): { [key: string]: any } => {
    const result: { [key: string]: any } = {};
    for (const key in obj) {
        if (!prefixes.some(prefix => key.startsWith(prefix))) {
            result[key] = obj[key];
        }
    }
    return result;
};
// End Verndale Customization

addToChainAfter(chain, PopulateApiParameter, props => {
    props.apiParameter.cartLine.properties = removeKeysWithPrefixes(props.apiParameter.cartLine.properties, [
        "isc_",
        "product_",
    ]);
});
